module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/gabriel-neely-6a1961d14f1ac2e6d0726b0484d5f431.png";